import { render, staticRenderFns } from "./AlertBar.vue?vue&type=template&id=6b91cf24&"
import script from "./AlertBar.vue?vue&type=script&lang=js&"
export * from "./AlertBar.vue?vue&type=script&lang=js&"
import style0 from "./AlertBar.vue?vue&type=style&index=0&id=6b91cf24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports